import { Component, OnInit } from '@angular/core';
import {Router, Event, ActivatedRoute, NavigationStart, NavigationEnd, NavigationCancel,
   NavigationError } from '@angular/router';
   import {LoadingService  } from "./loading.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [LoadingService]
})
export class AppComponent implements OnInit{

  title = 'omolayo';

  loading:boolean = true;
  constructor(private router: Router, private loadingservice:LoadingService){


    this.router.events.subscribe((routerEvent:Event)=>{
      if(routerEvent instanceof NavigationStart || this.loadingservice.loading == true){
        this.loading=true;
        console.log(this.loading);
      }
      if((routerEvent instanceof NavigationError ||
        routerEvent instanceof NavigationCancel ||
    routerEvent instanceof  NavigationEnd) && this.loadingservice.loading == false){
        this.loading = false;
        console.log(this.loadingservice.loading);
      }

    }
    );




  }
  ngOnInit(){
    console.log(this.loadingservice.loading);
    if(this.loadingservice.loading == false){
      this.loading = false;
    }else{
    this.loading = true;
    }
    console.log(this.loadingservice.loading);
  }


}
